export default __webpack_public_path__ + "static/media/art-brw-poster-2.f51cba71.jpg";